<template>
  <div class="big">
    <div class="container">
      <div>
        <div class="box">
          <div class="searchbox">
            <div class="item">
              <span>患者姓名</span>
              <el-input
                placeholder="请输入"
                v-model="user_name"
                style="width: 160px; margin-left: 12px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>手机号</span>
              <el-input
                placeholder="请输入"
                v-model="phone"
                style="width: 160px; margin-left: 12px"
                @input="search"
                clearable
              ></el-input>
            </div>

            <div class="item">
              <span>提交时间</span>
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="~"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width: 264px; margin-left: 12px"
                @change="search"
                clearable
              ></el-date-picker>
              <el-button
                type="info"
                style="
                  background-color: #eceff2;
                  color: #747981;
                  margin-left: 10px;
                "
                @click="search"
                >查询</el-button
              >
            </div>
          </div>
          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column
                label="提交时间"
                prop="create_time"
              ></el-table-column>

              <el-table-column
                label="患者姓名"
                prop="user_name"
              ></el-table-column>

              <el-table-column label="性别">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.sex == 1">男</span>
                    <span v-if="scope.row.sex == 2">女</span>
                    <span v-if="scope.row.sex == 0">未知</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="年龄" prop="age"></el-table-column>
              <el-table-column label="手机号" prop="phone">
                <template slot-scope="scope">
                  <div class="align-center">
                    <span>{{ scope.row.phone }}</span>
                    <img
                      v-if="
                        scope.row.phone &&
                        (module_id_array[0]
                          ? module_id_array.includes('1756')
                          : true)
                      "
                      class="phone-box"
                      src="https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/upload/common/20240521/171627515049458.png"
                      alt
                      @click="callBtn(7, scope.row.pic_id)"
                    />
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="处方图片">
                <template slot-scope="scope">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="scope.row.picture"
                    :preview-src-list="[scope.row.picture]"
                  ></el-image>
                </template>
              </el-table-column>

              <el-table-column label="剂型">
                <template slot-scope="scope">
                  <div v-if="scope.row.drug_type == 1">颗粒</div>
                  <div v-if="scope.row.drug_type == 2">饮片</div>
                </template>
              </el-table-column>
              <el-table-column label="剂数" prop="total_num"></el-table-column>
              <el-table-column label="备注" prop="remark"></el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
              style="margin: 20px 0"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import dayjs from "dayjs";

export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      user_name: "",
      phone: "",
      date: [],
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        user_name: this.user_name,
        doctor_name: this.doctor_name,
        phone: this.phone,
        status: 3,
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.create_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }

      this.axios
        .post("platform/photograph/getPrescriptionPictureList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = moment
                .unix(item.create_time)
                .format("YYYY-MM-DD HH:mm");

              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },

    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //查看订单详情
    toPre(row) {
      this.$router.push({
        path: "savepre",
        query: {
          row: JSON.stringify(row),
        },
      });
    },
    //作废
    toVoid(pic_id) {
      this.$confirm("确定作废拍方记录？", "确认作废", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.axios
            .post("platform/photograph/cancelPrescriptionPicture", { pic_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("记录已作废");
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
  },
  created() {
    this.getList();
  },
  activated() {
    this.getList();
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 1px 20px;
  .phone-box {
    width: 18px;
    height: 18px;
    padding: 0 6px;
    cursor: pointer;
  }
  .searchbox {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .item {
      margin-right: 30px;
      margin-top: 24px;
      display: flex;
      align-items: center;
    }
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.dialog {
  padding: 20px 20px 0;
}
</style>
